import {
	SET_SUBMODULES,
	SET_SUBMODULE,
	CLEAR_SUBMODULES,
	CLEAR_SUBMODULE,
	ADD_SUBMODULE,
	UPDATE_SUBMODULE,
	REMOVE_SUBMODULE,
} from './actionTypes';

export const submodule = (state = {}, action) => {
	switch (action.type) {
		case SET_SUBMODULE:
			return action.payload;
		case UPDATE_SUBMODULE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_SUBMODULE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_SUBMODULES:
			return action.payload;
		case ADD_SUBMODULE:
			return [...state, action.payload];
		case UPDATE_SUBMODULE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_SUBMODULE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_SUBMODULES:
			return [];
		default:
			return state;
	}
};
